import { render, staticRenderFns } from "./BreakpointWatcher.vue?vue&type=template&id=6f91bf4a&"
import script from "./BreakpointWatcher.vue?vue&type=script&lang=js&"
export * from "./BreakpointWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports